import { Analytics } from '@cobliteam/analytics';
import { Location } from '@cobliteam/common-types';
import useCameraAssociation from '@cobliteam/hooks/src/useCamera/useCameraAssociation';
import { Button, Tag } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { ReactComponent as SadFace } from '@cobliteam/ui-business/icons/face-id/sad-face.svg';
import { Link } from 'react-router-dom';

const DisabledFaceIdTag = () => {
  const { getCameraAssociation } = useCameraAssociation();
  const { data: cameraAssociation } = getCameraAssociation();
  const isFaceIdDisabled = cameraAssociation?.associationConfig?.entireFleetAssociationConfig?.isOn === false;

  const handleClick = () => {
    Analytics.track('Face Recognition - Navigate - Config');
  };

  if (!isFaceIdDisabled) return null;

  return (
    <div className='flex items-center gap-2'>
      <Tag variant='surface' size='sm' icon={<SadFace />} label='FaceID desativado' className='[&_svg]:!size-4' />
      <Link to={Location.CONFIG_FACE_ID} target='_blank'>
        <Button size='sm' variant='outlined' color='default' startIcon={<Icon name='external-link' />} onClick={handleClick}>
          Ativar agora
        </Button>
      </Link>
    </div>
  );
};

export default DisabledFaceIdTag;
